export const createText = (text: string) => ({ __html: text });
